const initialState = {
  isOpen: false,
  action: "",
  payload: null,
  obj:null,
  tableDataCurrent:[],
  refresh:0,
  question:"",
  answer:"",
  emailId:null,
  updateSpinner:false,
  // refreshState:false,
  // footerLoader:false
};

const drawerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // case "zIndexFooterLoaderAction":
    //   state = { ...state, footerLoader: payload };
    // case "RefreshAction":
    //   state = { ...state, refreshState: payload };
    case "isDrawerOpen":
      state = { ...state, isOpen: payload };
      return state;
    case "DrawerAction":
      state = { ...state, action: payload };
      return state;
    case "DrawerPayload":
        state = { ...state, payload: payload };
        return state;
    case "DrawerPropData":
        state = { ...state, obj: payload };
        return state;
    case "ingestedSelectedData":
        state = { ...state, tableDataCurrent: payload };
        return state;
    case "ingestedrefreshData":
        state = { ...state, refresh: state.refresh+1 };
        return state;
    case "getIngestedEmailAnswer":
          state = { ...state, answer: payload };
          return state;
    case "getEmailId":
    state = { ...state, emailId: payload };
      return state;
      
 case "getIngestedEmailQuestion":
            state = { ...state, question: payload };
            return state;
            case "getUpdatedSpinner":
              state = { ...state, updateSpinner: payload };
              return state;
  
            // getUpdatedSpinner
        // getIngestedEmailAnswer
        // getIngestedEmailQuesiton
    default:
      return state;
  }
};
export default drawerReducer;
